import React from 'react'
import PropTypes from 'propTypes'
import { NavLink } from 'react-router-dom'
import { cx } from '@emotion/css'
import styles from './styles'

const DropdownLink = ({ active, to, href, target = '_self', onClick, label, rel }) => {
  const Component = to ? NavLink : 'a'
  const props = to ? { to, onClick } : { href, onClick, target, rel }

  return (
    <li role="menuitem">
      <Component {...props} className={cx(styles.link, active && styles.linkActive)}>
        {label}
      </Component>
    </li>
  )
}

DropdownLink.propTypes = {
  active: PropTypes.bool,
  href: PropTypes.string,
  to: PropTypes.string,
  target: PropTypes.string,
  onClick: PropTypes.func,
  label: PropTypes.string.isRequired,
  rel: PropTypes.string,
}

export default DropdownLink
